<template>
    <div class="form">
        <h4 class="step-title">
            Does your home have a home security system?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <scrollable-button-list v-bind:items="homeSecuritySystemTypes" v-bind:onclick="complete" v-bind:value="lead.homeInsurance.homeSecuritySystemType"/>
        </div>
    </div>
</template>

<script>
    import ScrollableButtonList from "../shared/ScrollableButtonList.vue"

    export default {
        name: "HomeSecuritySystem",
        components: {
            ScrollableButtonList
        },
        data: function() {
            return {
                homeSecuritySystemTypes: [
                    { text: "Yes", value: "InHomeOnly" },
                    { text: "No", value: "None" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(value) {
                this.lead.homeInsurance.homeSecuritySystemType = value;
                this.$emit("complete", this.$options.name, value);
            }
        }
    }
</script>
